import { syncSessionSelectionFamilyAtom } from '@/features/consolidatedSessionsList/atoms';
import { type ConsolidatedSession } from '@/features/consolidatedSessionsList/types';
import { getSessionUniqueId } from '@/features/consolidatedSessionsList/utils/getSessionUniqueId';
import { useSetAtom } from 'jotai';
import { useEffect } from 'react';

/**
 * Prunes the sessionSelectedAtomFamily cache whenever the visible session list changes.
 * Removes cached atoms for sessions that are no longer visible and not selected.
 */
export const useSessionSelectionCleanup = (sessions: ConsolidatedSession[]) => {
  const syncFamily = useSetAtom(syncSessionSelectionFamilyAtom);

  useEffect(() => {
    const visibleIds = sessions
      .map(getSessionUniqueId)
      .filter((id): id is string => !!id);
    syncFamily(visibleIds);
  }, [sessions, syncFamily]);
};
